<!-- application-details.component.html -->
<!-- Module 5 — Update Existing Assessment : Application Details (Coming Soon) -->

<div class="coming-soon-page">
  <div class="coming-soon-page__card">

    <!-- Icon -->
    <div class="coming-soon-page__icon-wrap" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10
                 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
              fill="#198FCB"/>
      </svg>
    </div>

    <!-- Text -->
    <h2 class="coming-soon-page__heading">Coming Soon</h2>
    <p class="coming-soon-page__body">
      This feature is currently under development and will be available in a future release.
    </p>

    <!-- Back button -->
    <button class="coming-soon-page__btn"
            type="button" routerLink="/" aria-label="Back to home">
      ← Back to Home
    </button>

  </div>
</div>
